/**
 * Hareruya (Japan) links. NOT an affiliate link: the store has no referral
 * program we can join (plan 2026-10-04, section 2). The per-card link is the
 * store's search for the English name exactly as the deck spells it; phase 0
 * checked Sol Ring, Rhystic Study, Fable of the Mirror-Breaker and Fire // Ice.
 * The results render client-side, so the page itself always answers 200.
 */

const HARERUYA_SEARCH = 'https://www.hareruyamtg.com/ja/products/search?product='

/** The list-import page (phase 0, Keith 2026-10-04): a deck builder that
 *  imports Arena-format lists, with a whole-deck purchase button. */
export const HARERUYA_LIST_URL = 'https://deck.hareruyamtg.com/'

export function hareruyaCardUrl(cardName: string): string {
  return HARERUYA_SEARCH + encodeURIComponent(cardName.trim())
}
